import { Fragment } from 'react';

export function TerminationOfAccounts() {
  return (
    <Fragment>
      <em>By Us</em><br />
      We reserve the right to terminate an account at any time and for any reason, without notice, and at the full discretion of our Company. Abuse of Services, copyright violations, violations of these terms, and payment fraud are examples of behaviour that would be cause  for termination, but this is not an exhaustive list. 
      <br /><br />
      We will attempt to give reasonable notice to accounts at risk of termination and attempt to reach a solution. However, notification is not always possible and we will not be held liable for losses incurred as a result of sudden termination.
      <br /><br />
      <em>By You</em><br />
      A User reserves the right to terminate his/her account at any time and for any reason, without notice, and at his/her full discretion. Refunds will not be granted for the current billing cycle in the event of termination, unless expressly granted under our Cancellations and Refund Policy, and access to Premium features will continue until the end of the current billing cycle. 
      <br /><br />
      Refunds cannot be granted for any CityFALCON Coins that remain on accounts that are terminated.
      <br /><br />
      <em>How Users May Terminate their Accounts</em><br />
      Account termination is only possible through the Subscription Portal on the CityFALON website. We will not accept termination requests through email or other messages except in cases when it has been documented that termination through the Subscription Portal is disabled or otherwise impossible.
      <br /><br />
      <em>State of Personal Data after Account Termination</em><br />
      Financial data is stored with our third party payment processing partner and we refer Users to that partner’s policies regarding the storage of personal financial information following termination.
      <br /><br />
      User data stored on CityFALCON servers, such as location, preference, website activities, and account information, will be collected, stored, and used in accordance with our <a href="/privacy">Privacy Policy</a>.
    </Fragment>
  );
}


export default TerminationOfAccounts;
